module.exports = __webpack_public_path__ + "static/media/copiapo.98939044.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/andimar/destinations/copiapo.png
// module id = 1170
// module chunks = 0